<template>
  <div >
     <store-selector />

     <b-row class="m-b-20">
       <b-col cols="8">
         <h3>Upsell Automations </h3>
       </b-col>
       <b-col cols="4">
          <b-btn variant="primary" class="float-right" @click="addNew"><i class="fa fa-plus-circle" aria-hidden="true"></i> Add New </b-btn>
          <b-btn variant="dark" class="float-right m-r-10" @click="goToLogs">
             Logs
          </b-btn>
       </b-col>
     </b-row>
     <transition name="fade" mode="out-in">
        <router-view></router-view>
     </transition>
  </div>
</template>

<script>
  const StoreSelector = () => import( /* webpackChunkName: "store.selector" */ '../../../components/dashboard-widgets/store-selector')
  const UpsellAutomationList = () => import(/* webpackChunkName: "upsell-automation-list" */ './upsell-automation-list')
  export default {
     components: {StoreSelector, UpsellAutomationList},
     computed: {
        storeInState() {
          return this.$store.state.ecommerceStore.store
        },
    },
    methods: {
      addNew(){
         this.$router.push({name: 'upsell-add-update-automation'})
      },
      goToLogs(){
        this.$router.push({name: 'upsell-logs'})
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>